import { call, takeLatest } from "redux-saga/effects";
import { confirmGuestApi, confirmGuestByGuestApi, confirmGuestBySponsorApi, confirmSponsorApi } from "../../services/api/users";
import { REQUEST_API_CONFIRM_BY_GUEST, REQUEST_API_CONFIRM_BY_SPONSOR, REQUEST_API_CONFIRM_GUEST, REQUEST_API_CONFIRM_SPONSOR } from "../actions/actions";

function* confirmGuestBySponsor({ data: { id, callback } }) {
  try {
    yield call(confirmGuestBySponsorApi, id);
    callback();
  } catch (e) {}
}
function* confirmGuestByGuest({ data: { id, token, callback } }) {
  try {
    // do api call
    yield call(confirmGuestByGuestApi, id, token);
    callback();
  } catch (e) {}
}
function* confirmSponsor({ data: { id, body, callback } }) {
  try {
    // do api call
    const res = yield call(confirmSponsorApi, id, body);
    const { status } = res;
    callback(status || res.response.status);
  } catch (e) {}
}
function* confirmGuest({ data: { id, token, body, callback } }) {
  try {
    // do api call
    const res = yield call(confirmGuestApi, id, token, body);
    const { status } = res;
    callback(status || res.response.status);
  } catch (e) {}
}

/*
  Alternatively you may use takeLatest.
  Does not allow concurrent fetches of Companie. If "COMPANIE_FETCH_REQUESTED" gets
  dispatched while a fetch is already pending, that pending fetch is cancelled
  and only the latest one will be run.
*/

export function* confirmGuestBySponsorSaga() {
  yield takeLatest(REQUEST_API_CONFIRM_BY_SPONSOR, confirmGuestBySponsor);
}
export function* confirmGuestByGuestSaga() {
  yield takeLatest(REQUEST_API_CONFIRM_BY_GUEST, confirmGuestByGuest);
}
export function* confirmSponsorSaga() {
  yield takeLatest(REQUEST_API_CONFIRM_SPONSOR, confirmSponsor);
}
export function* confirmGuestSaga() {
  yield takeLatest(REQUEST_API_CONFIRM_GUEST, confirmGuest);
}
